import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * The session is settled by an app initializer in `app.config.ts`, not here: a check started
 * from `ngOnInit` races the router's first navigation, and the guards lose that race.
 */
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent {}
